import {useEventListener} from '@vueuse/core'
import {useRouter} from 'vue-router'
import {isElectron} from '@toolify/client/src/modules/electron/singletons/isElectron'
import {useWorkspaceTabStore} from '@toolify/client/src/stores/WorkspaceTabStore/useWorkspaceTabStore'
import {isOpenInNewTabPointerEvent} from '@toolify/client/src/modules/workspaceTabs/functions/isOpenInNewTabPointerEvent'
import {getMiddleClickAnchor} from '@toolify/client/src/modules/workspaceTabs/functions/getMiddleClickAnchor'
import {getInternalPathFromAnchor} from '@toolify/client/src/modules/workspaceTabs/functions/getInternalPathFromAnchor'

export function useWorkspaceTabMiddleClick(): void {
  const router = useRouter()
  const workspaceTabStore = useWorkspaceTabStore()

  function tryOpenHrefAsTab(event: MouseEvent): void {
    if(!isElectron() || !isOpenInNewTabPointerEvent(event)) {
      return
    }
    const anchor = getMiddleClickAnchor(event)
    if(!anchor) {
      return
    }
    const path = getInternalPathFromAnchor(anchor)
    if(!path) {
      return
    }
    event.preventDefault()
    event.stopPropagation()
    workspaceTabStore.syncFromRoute(router.resolve(path))
  }

  useEventListener(document, 'auxclick', tryOpenHrefAsTab, {capture: true})
  useEventListener(document, 'click', tryOpenHrefAsTab, {capture: true})
  useEventListener(document, 'mousedown', tryOpenHrefAsTab, {capture: true})
}
